
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import FavoriteUrlViewer from "./FavoriteUrlViewer";
   
import Gistviewer from "./Gistviewer";
 
function Developer() {
    return (
        <div className="container">

          
            <div className="row">
                <div className="col">
                    <Tabs
                        defaultActiveKey="about"
                        id="uncontrolled-tab-example"
                        className="mb-3"
                    >
                        <Tab eventKey="about" title="About">
                            <p>I've been working with computers since I first got a Commodore VIC 20 in the eighties.  Check here regularly for any software development tips I've encountered over the year.
                           I currently do full stack developlment with .net and react.
                            </p>
                        </Tab>
                        <Tab eventKey="gists" title="Gists">
                        <p>Some code snippets.  I store these as gists on github.   </p>
                            <Gistviewer />
                        </Tab>
                        <Tab eventKey="links" title="links"  >
                        <p>These are some links I use for practicing react.  </p>
                            <FavoriteUrlViewer />
                        </Tab>
                    </Tabs>
                </div>

            </div>





            </div>

    );
}

export default Developer